import React, { useContext } from "react";
import "./Header.css";
import {Link, NavLink} from "react-router-dom";
import logo from "../assets/logo_birdsdessines.png";
import crosshair from "../assets/hunt/ui/crosshair.png";
import ConnectionButton from "./ConnectionButton";
import { UserContext } from "../contexts/UserContext";
import { MagnifyingGlassIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

interface HeaderProps {

}

const Header:React.FC<HeaderProps> = () => {
    const { isModerator } = useContext(UserContext);

    return (
        <div className={"Header"}>
            <div className={"TopBar"}>
                <div className={"TopBar-brand"}>
                    <Link to={"/"}><img className={"logo"} src={logo} alt={"Logo Birds Dessinés"}/></Link>
                    <Link to={"/hunt"} className={"HuntEgg"} aria-label={"Chasse aux Birds"} title={"Chasse aux Birds"}>
                        <img src={crosshair} alt={""} aria-hidden={"true"}/>
                    </Link>
                </div>
                <ConnectionButton/>
            </div>

            <nav className={"TopNav"}>
                <ul>
                    <li><NavLink to={"/last"}>Le Fil</NavLink></li>
                    <li><NavLink to={"/top"}>Le Top</NavLink></li>
                    <li><NavLink to={"/verbis"}>Verbis</NavLink></li>
                    <li><NavLink to={"/editor"}>Éditeur</NavLink></li>
                    {isModerator() && (
                        <li>
                            <NavLink to={"/moderation"} className="TopNav-modo" aria-label="Modération">
                                <ShieldCheckIcon className="modo-icon" />
                            </NavLink>
                        </li>
                    )}
                    <li>
                        <NavLink to={"/search"} className="TopNav-search" aria-label="Recherche">
                            <MagnifyingGlassIcon className="search-icon" />
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default Header;